// 对应后端 cn.edu.sdu.web.controller.server.entity.MsgActionEnum
const msgAction = {
  CONNECT: 1,
  CHAT: 2,
  SIGNED: 3,
  KEEPALIVE: 4,
  PULL_FRIEND: 5,
  PULL_FRIEND_REQ: 6,
  GROUP_CHAT: 7,
  GROUP_SIGNED: 8,
};

export default msgAction;
